import ApiMock from './ApiMock';

import filter from 'lodash/filter'
import includes from 'lodash/includes'
import cloneDeep from 'lodash/cloneDeep';

import IddDataMock from "./data/IddData";
import { DataTypes } from './../../libs/DataTypes'

ApiMock.onGet(/^.+\/api\/internal\/v1\/accommodations_data(\/)?((\?.+)(\&.+)*)*/).reply((config) => {

    //return [401, 'Non autorizzato!']; // Test error

    const accommodationsData = cloneDeep(filter(IddDataMock, (e) => includes(DataTypes.accommodations, e.data_type)))

    /* Re-build response */
    const response = {accommodations_data: accommodationsData}
    return [200, response]
})





// WEBPACK FOOTER //
// ./src/sources/mocks/AccommodationsDataApiMock.js